import { takeLatest, all, fork, put, call } from 'redux-saga/effects';
import Actions from 'actions';
import api from 'api';

function* fetchCityInfo({ id, callbacks }) {
  try {
    const response = yield call(api.fetchCityInfo, id);
    yield put(Actions.fetchCityInfoSuccess(response?.data));
    if (typeof callbacks?.success === 'function') {
      yield call(callbacks.success, response.data);
    }
  } catch (error) {
    yield put(Actions.fetchCityInfoFail(error));
    if (typeof callbacks?.failure === 'function') {
      yield call(callbacks.failure, error);
    }
  }
}

function* watchFetchCity() {
  yield takeLatest(Actions.FETCH_CITY_INFO_REQUEST, fetchCityInfo);
}

export default function* list() {
  yield all([fork(watchFetchCity)]);
}
